/**
 * Blank image, can be used to show <img> background while loading.
 */
export const BLANK_IMG =
  'data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22/%3E';
